import { Button } from 'blaze-ui/Button'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { ArrowRight } from 'blaze-ui/icons'
import { multiStep } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/multiStep'
import { useFormikContext, FormikValues } from 'formik'
import { TopicField } from '../../../../Fields/TopicField'
import { BrandKitField } from '../../../../Fields/BrandKitField'
import { useAutocomplete } from 'components/Wizards/DesktopWizards/useAutocomplete'
import { PollFieldsetCompletion } from 'components/PollFieldsetCompletion/PollFieldsetCompletion'
import { useState, useEffect, useRef } from 'react'
import { useWizardSchema } from 'components/Wizards/Wizard/WizardContext'
import { MultiStepSchema, WizardType } from 'components/Wizards/schemas/Types'
import { Field as BaseField } from 'components/Wizards/MobileWizards/Field/Field'
import { Field } from 'components/Wizards/MobileWizards/Form/Field'

export const MultiPostPrompt = multiStep(({ schema, submit, getSchemaField }) => {
  const { meta } = schema.describe()
  const { values, setFieldValue, setStatus, initialStatus } = useFormikContext<FormikValues>()
  const topicField = getSchemaField('topic')
  const countField = getSchemaField('count')
  const [isLoading, setIsLoading] = useState(false)
  const hasInitialized = useRef(false)
  const userEditedTopic = useRef(false)

  const wizardSchema = useWizardSchema() as MultiStepSchema<WizardType>

  const { handleGenerate, handleComplete, data } = useAutocomplete({
    schema: wizardSchema,
    values,
    setFieldValue,
    setStatus,
    initialStatus,
    onLoadingChange: setIsLoading,
  })

  useEffect(() => {
    if (!hasInitialized.current) {
      hasInitialized.current = true

      if (topicField && !values.topic) {
        handleGenerate({ fields: ['topic'] })
      }
    }
  }, [topicField, values.topic, handleGenerate])

  const handleBrandKitChange = (brandKitId: number) => {
    if (userEditedTopic.current) return

    handleGenerate({ fields: ['topic'], newCompletedFields: { brand_kit_id: brandKitId } })
  }

  const handleTopicKeyDown = () => {
    userEditedTopic.current = true
  }

  return (
    <>
      <PollFieldsetCompletion fieldsetCompletionId={data?.fieldset_completion.id} onComplete={handleComplete} />
      <MobileWizard.Content>
        <MobileWizard.Section gap={10}>
          <MobileWizard.Title>{meta.title}</MobileWizard.Title>
          {meta.subtitle && <MobileWizard.Subtitle>{meta.subtitle}</MobileWizard.Subtitle>}
        </MobileWizard.Section>
        {topicField && (
          <BaseField name="topic" label={topicField.describe().meta.label}>
            <TopicField schema={topicField} isLoading={isLoading} onKeyDown={handleTopicKeyDown} />
          </BaseField>
        )}
        {countField && <Field name="count" schema={countField} />}
        <BaseField label="Pick a Brand Kit">
          <BrandKitField onBrandKitChange={handleBrandKitChange} />
        </BaseField>
      </MobileWizard.Content>
      <MobileWizard.ButtonFooter>
        <Button size="lg" variant="primary" endIcon={ArrowRight} fullWidth onPress={submit} isDisabled={isLoading}>
          Continue
        </Button>
      </MobileWizard.ButtonFooter>
    </>
  )
})
